export default __webpack_public_path__ + "static/media/laptop.d5b0d67c.png";